import React, { Component } from 'react'
import PropTypes from 'prop-types'

import { style, Container } from './Summary.style'


class Modal extends Component {
  render() {
    const { children, closeModal, isVisible, title, slimContent } = this.props
    
    return <Container>
      <div className="header1">SPECIAL PROMOTION</div>
      <div className="header-box">
        <div className="header-box1">
          Classic series
          <span className='small'>Model N5</span>
        </div>
        <div className="header-box2">
          <div className="old-price">
            MSRP $4,990
          </div>
          <div className="new-price">
            <small>
              <div className="from">
              STARTING AT
              </div> 
              <div>
              USD
              </div>
            </small>
            <span>$2,990</span>
          </div>
        </div>
      </div>
      <div className="header-box-description">
      (Price per seating position)
      </div>
     
      <ul className='ul-check'>
        {/* <li>Upholstered in CineSuede</li> */}
        {/* <li>Optional Contrast Stitching at No Charge</li> */}
        <li>Wholesale Discounts Available for Dealers and Designers</li>
      </ul>
      
      <p><b>FEATURES</b></p>

      <ul>
        <li>Made in Canada</li>
        <li>20 Year Warranty</li>
        <li>Power Recline</li>
        <li>Robust Build Quality </li>
        <li>Engineered for Public VIP Cinemas   </li>
        <li>Heavy Duty Recliner Mechanism</li>
        <li>Wall Hugger Incliner (4” wall clearance)</li>
        <li>Commercial Grade Wood Frame</li>
        <li>Chiropractic Endorsed Ergonomic Design</li>
        <li>Premium, High Quality Seating Foam <br/>(available in soft, medium or firm)</li>
      </ul>

    </Container>
  }
}

Modal.propTypes = {}

export default Modal
